import { BuildingDTO } from "./building";
import { UnitDTO } from "./unit";

export enum ElectricityCertificateContentStatus {
    VALID = "Conform",
    VALID_WITH_REMARKS = "Conform, maar met opmerkingen",
    INVALID = "Niet conform",
    ONBEKEND = "Niet nagekeken"
}

export enum ElectricityInfoLevel {
    UNIT = "unit",
    BUILDING = "building"
}

export enum ElectricityConnectedTo {
    PRIVATE = "Private meter",
    COMMON = "Gemeenschappelijke meter"
  }

export type ElectricityInfoDto = {
    id?: number;
    unit?: UnitDTO;
    building?: BuildingDTO;
    unitId?: string;
    buildingId?: string;
    level: ElectricityInfoLevel;
    electricityCertificateStatus?: ElectricityCertificateContentStatus;
    remarks?: string
    electricityCertificateFileLogId?: number;
    electricityCertificateFileLog?: any;
    electricitySchemaFileLogId?: number;
    electricitySchemaFileLog?: any;
    electricitySituationPlanFileLogId?: number;
    electricitySituationPlanFileLog?: any;
    mainCircuitAmperage?: number;
    electricityMeter?: any;
    electricityConnectedTo: ElectricityConnectedTo;
}